import * as mobx from 'mobx'
import PT from 'prop-types'
import R from 'ramda'
import colors from '@vimcar/shared-utils/styles/colors'

import { BREAKPOINT_DESKTOP } from '#utils/ui'

const mkStore = (
  params,
  { walkThroughSteps },
  { viewport }
) => {
  const store = mobx.observable({
    showWalkthrough: mobx.computed(() =>
      viewport.is(BREAKPOINT_DESKTOP)
    ),

    walkThroughSteps: mobx.computed(() =>
      R.map((step) => ({
        title: step.title,
        text: step.text,
        selector: step.selector,
        position: step.position,
        allowClicksThruHole: true,
        style: R.mergeDeepRight(
          {
            mainColor: colors.colorPrimary,
            button: {
              display: 'initial',
              backgroundColor: colors.colorPrimary,
            },
            borderRadius: 4,
            main: {
              fontSize: 15,
              lineHeight: '20px',
              paddingBottom: '15px',
            },
          },
          step.style || {}
        ),
      }), walkThroughSteps)
    ),
  })
  return store
}

mkStore.propTypes = {
  steps: PT.array,
}

mkStore.contextTypes = {
  viewport: PT.object,
}

export default mkStore
